export class InvalidSourceSystemError extends Error {
  code: 'ErrInvalidSourceSystem';
}
